<span class="ui-badge" [ngClass]="'ui-badge--' + variant">
  <span class="ui-badge__dot" *ngIf="showDot"></span>
  {{ label }}
</span>
